import React, { useState, useContext, useEffect } from "react";
import { showInfoToast } from "../../validation/ToastContainer";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
import { PopupContext } from "../../index"
import { saveMLLearningPeriod, getMLLearningPeriod } from "../system-settings/systemSettingsService";


export default function MLLearningPeriodSection() {

  const { setPopup } = useContext(PopupContext);
  const [learningPeriod, setLearningPeriod] = useState('0');

  const isStartDisabled = false;

  const fetchData = async () => {
    try {
      let x = await getMLLearningPeriod();
      setLearningPeriod(x.value);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSetMLLearningPeriodClick = event => {
    showInfoToast('Setting ML Learning Period', 'ML Learning Period');

    setPopup(
      getConfirmPopup('Are you sure?',
        'Octopus VAR ML Learning Period',
        () => onConfirm()
      )
    );

    const onConfirm = async () => {
      saveMLLearningPeriod(learningPeriod);
    };
  };

  const changeMLLearningPeriod = (value) => { setLearningPeriod(value); }

  return (
    <>
      <p className="oct_settings-description">
        ML Learning Period: Time needed by the system to learn enough data before start giving reliable predictions.
      </p>

      <div className="oct_settings-form-grid">
        <div className="oct_settings-field">
          <label className="oct_settings-label">ML Learning Period</label>
          <input
            className="oct_settings-input-v2"
            type="number"
            value={learningPeriod}
            onChange={event => changeMLLearningPeriod(event.target.value)}
          />
        </div>
        <div className="oct_settings-field">
          <label className="oct_settings-label">Unit</label>
          <select className="oct_select-v2" disabled>
            <option value="Days">Days</option>
          </select>
        </div>
      </div>

      <button
        className={`oct_settings-btn-v2 ${isStartDisabled ? 'disabled' : ''}`}
        onClick={onSetMLLearningPeriodClick}
      >
        Save ML Learning Period
      </button>
    </>
  );
}
